export var RankEnum;
(function (RankEnum) {
    RankEnum[RankEnum["same"] = 0] = "same";
    RankEnum[RankEnum["min"] = 1] = "min";
    RankEnum[RankEnum["source"] = 2] = "source";
    RankEnum[RankEnum["max"] = 3] = "max";
    RankEnum[RankEnum["sink"] = 4] = "sink";
})(RankEnum || (RankEnum = {}));
//# sourceMappingURL=rankEnum.js.map